import React from "react";
import { Smartphone, Tv2, Apple, Monitor, Wifi, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import VisitorCounter from "./VisitorCounter";
import { Logo } from "./Logo";
import { BRAND } from "../config/brand";

const WA_LINK = `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent("Olá! Quero testar grátis o MasterX HD na minha Smart TV / TV Box.")}`;

export default function Footer() {
  return (
    <footer className="max-w-[1500px] mx-auto px-6 mt-20">
      <div className="rounded-2xl bg-gradient-to-br from-brand/10 via-surface to-ink border border-white/10 p-8 md:p-10">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight">
              Suporte <span className="brand-gradient-text">MasterX</span>
            </h3>
            <p className="text-white/65 mt-2">
              Canais travando? Clique aqui e teste Grátis em sua Smartv ou TV Box.
            </p>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white font-semibold shadow-lg shadow-[#25D366]/30 transition"
            >
              <MessageCircle className="w-4 h-4" /> FALAR NO WHATSAPP
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {[
              { icon: Smartphone, label: "Android" },
              { icon: Tv2, label: "Smart TV" },
              { icon: Apple, label: "iOS" },
              { icon: Monitor, label: "TV Box" },
              { icon: Wifi, label: "Roku" },
            ].map(({ icon: Icon, label }) => (
              <div key={label} className="p-4 rounded-xl bg-white/5 border border-white/10 hover:border-brand/50 transition flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-brand/15 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-brand-light" />
                </div>
                <span className="text-sm font-semibold text-white/85">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="text-center py-6 text-xs text-white/40 space-y-2">
        <div className="flex flex-col items-center gap-1">
          <Logo className="h-28 md:h-32" testId="footer-logo" />
          <a href={`https://${BRAND.domain}`} className="text-brand-light font-semibold hover:underline" data-testid="footer-domain-link">{BRAND.domain}</a>
          <nav className="flex items-center gap-4 mt-1 text-silver/70">
            <Link to="/revenda" data-testid="footer-revenda-link" className="hover:text-brand-2 transition-colors">Seja Revendedor</Link>
            <Link to="/baixar" data-testid="footer-baixar-link" className="hover:text-brand-2 transition-colors">Baixar App</Link>
          </nav>
        </div>
        <VisitorCounter />
      </div>
    </footer>
  );
}
